module.exports = __webpack_public_path__ + "src/img/zalando/img-modules.8c58f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-modules.jpg
// module id = 127
// module chunks = 0